import { Flex } from "../Flex";
import { Tooltip } from "../../utils/local-antd";
import { TextWithTruncated } from "../TextWithTruncated";
import { CopyButton } from "../CopyButton";
import styled, { DefaultTheme } from "styled-components";
import { EntryKind } from "../../model/entry/types/EntryKind.enum";
import { Rounded } from "../../theme/Rounded";
import { useTranslation } from "react-i18next";
import { Button } from "../Button";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { Spacing } from "../../theme/Spacing";

const Container = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.s};
  padding: ${Spacing.xs};
  border-radius: ${Rounded.md};
`;

const EmailButton = styled(Button)<{ kind?: EntryKind }>`
  padding: 0;
  margin: 0;
  background-color: ${({ theme }) => theme.white};
  border-radius: ${Rounded.circle};
  height: 2rem;
  width: 2rem;
  color: ${({ theme, kind }) =>
    kind ? theme[kind.toLowerCase() as keyof DefaultTheme] : theme.black};
`;

const StyledCopyButton = styled(CopyButton)<{ kind?: EntryKind }>`
  margin: 0 !important;
  padding: 0 !important;
  background-color: ${({ theme }) => theme.white};
  border-radius: ${Rounded.circle};
  height: 2rem;
  width: 2rem;

  svg {
    color: ${({ theme, kind }) =>
      kind ? theme[kind.toLowerCase() as keyof DefaultTheme] : theme.black};
  }

  &:hover {
    background-color: ${({ theme }) => theme.white};
  }
`;

type Props = {
  email?: string;
  extra?: {
    kind?: EntryKind;
  };
};

export const TableActionableCellEmail: React.FC<Props> = ({ email, extra }) => {
  const { t } = useTranslation();

  if (!email?.length) {
    return null;
  }

  return (
    <Container className="actionable-cell">
      <Flex gap="s" alignItems="center">
        <Tooltip title={t("entries.table.settings.columns.email.title")}>
          <EmailButton
            onClick={() => {
              if (email) {
                window.open(`mailto:${email}`, "_blank");
              }
            }}
            iconWidth="lg"
            icon={faEnvelope}
            kind={extra?.kind}
          />
        </Tooltip>

        <TextWithTruncated length={30} direction="ltr">
          {email}
        </TextWithTruncated>
      </Flex>
      <StyledCopyButton copy={email} iconSize="lg" kind={extra?.kind} />
    </Container>
  );
};
